import React from 'react';
import { CheckboxProps } from 'semantic-ui-react';

import { Segment } from '@modules/common/components/Segment';
import Checkbox from '@modules/common/components/Checkbox';
import { styled } from '@modules/common/components/ThemeProvider/utils';

import { ALL_ORIGINS, isAllowedOriginSet, allOriginsAllowed, EMPTY_ORIGIN } from '../../utils';

type Props = {
  allowedOriginDomains?: string[];
  setAllowedOriginDomains: (origins?: string[]) => void;
};

function SelectedAllowedOrigins({ allowedOriginDomains, setAllowedOriginDomains }: Props) {
  function onAllowAllDomains(_: any, data: CheckboxProps) {
    if (data.checked) {
      setAllowedOriginDomains([ALL_ORIGINS]);
    } else {
      setAllowedOriginDomains([EMPTY_ORIGIN]);
    }
  }

  return (
    <StyledSelectedDomainsWrapper>
      <StyledAllowedOriginsHeader>
        <StyledLabelSegment basic>
          <b>Allowed origins:</b>
        </StyledLabelSegment>
        {allOriginsAllowed(allowedOriginDomains) ? (
          <StyledLabelSegment basic>All origins allowed.</StyledLabelSegment>
        ) : (
          !isAllowedOriginSet(allowedOriginDomains) && (
            <StyledLabelSegment basic>No allowed origins.</StyledLabelSegment>
          )
        )}
      </StyledAllowedOriginsHeader>
      <Checkbox
        label="Allow all domains"
        checked={allOriginsAllowed(allowedOriginDomains)}
        onChange={onAllowAllDomains}
      />
    </StyledSelectedDomainsWrapper>
  );
}

export default SelectedAllowedOrigins;

const StyledSelectedDomainsWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 0rem 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
`;

const StyledLabelSegment = styled(Segment)`
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin: 0 !important;
`;

const StyledAllowedOriginsHeader = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;
